import { RemoveCircleOutlined } from '@mui/icons-material'
import { Button } from '@mui/material'

export const CompactRemoveButton = (props) => {
  return (
    <Button color='primary' size='small' {...props}>
      <RemoveCircleOutlined fontSize='small' />
      {'\u2063'}
    </Button>
  )
}

export default CompactRemoveButton
